import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
  name: "space"
})
export class SpacePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (!value || typeof value !== 'string') {
      return value;
    }

    // Find the first digit in the string to insert the space before it
    const firstDigitIndex = value.search(/\d/);
    if (firstDigitIndex === -1) {
      return value;
    }

    return value.substring(0, firstDigitIndex) + ' ' + value.substring(firstDigitIndex);
  }
}
